import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-right-red.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-right-orange.svg'


const _hoisted_1 = {
  class: "flex flex-col px-0 bg-lp-white w-full",
  "data-testid": "incoming-sti-dest-header-stt-bar"
}
const _hoisted_2 = { class: "flex text-gray-lp-300 pb-2 font-semibold" }
const _hoisted_3 = { class: "flex flex-row w-full gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "flex"
}
const _hoisted_5 = {
  key: 1,
  class: "flex text-20px font-semibold text-red-lp-300"
}
const _hoisted_6 = { class: "flex flex-grow text-12px font-semibold text-gray-lp-300" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "",
    class: "h-5 mx-auto"
  })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "flex"
}
const _hoisted_9 = {
  key: 1,
  class: "flex text-20px font-semibold text-yellow-lp-100"
}
const _hoisted_10 = { class: "flex flex-grow text-12px font-semibold text-gray-lp-300" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "",
    class: "h-5 mx-auto"
  })
], -1)
const _hoisted_12 = {
  key: 0,
  class: "flex"
}
const _hoisted_13 = {
  key: 1,
  class: "flex text-20px font-semibold text-yellow-lp-100"
}
const _hoisted_14 = { class: "flex flex-grow text-12px font-semibold text-gray-lp-300" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "",
    class: "h-5 mx-auto"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("stiDest.dashboard.headerSttBar")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "flex flex-grow gap-2 items-center cursor-pointer py-3 px-3 overflow-hidden border border-1 border-gray-lp-1300",
        style: {"border-radius":"12px","background-image":"linear-gradient(90deg, #33333300, #FFF9F7)"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickCard('pod')))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_Skeleton, {
                height: "24px",
                width: "88px"
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.totalPodString) + " STT ", 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("stiDest.dashboard.segeraPod")), 1),
        _hoisted_7
      ]),
      _createVNode("div", {
        class: "flex flex-grow gap-2 items-center cursor-pointer py-3 px-3 overflow-hidden border border-1 border-gray-lp-1300",
        style: {"border-radius":"12px","background-image":"linear-gradient(90deg, #33333300, #FFF9F7)"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickCard('rts')))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_Skeleton, {
                height: "24px",
                width: "88px"
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.totalRtsString) + " STT ", 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("stiDest.dashboard.segeraRts")), 1),
        _hoisted_11
      ]),
      _createVNode("div", {
        class: "flex flex-grow gap-2 items-center cursor-pointer py-3 px-3 overflow-hidden border border-1 border-gray-lp-1300",
        style: {"border-radius":"12px","background-image":"linear-gradient(90deg, #33333300, #FFF9F7)"},
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickCard('hal')))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode(_component_Skeleton, {
                height: "24px",
                width: "88px"
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.totalHalString) + " STT ", 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("stiDest.dashboard.segeraHal")), 1),
        _hoisted_15
      ])
    ])
  ]))
}